import React from "react";
import { GridColDef } from "@mui/x-data-grid-premium";
import { HotkeyCompliantDataGrid } from "src/components/common/dataGrid";
import { useTranslation } from "react-i18next";

export const PermissionsTableSkeleton: React.FC = () => {
  const { t } = useTranslation();

  const columns: GridColDef[] = [
    { field: "menuItem", headerName: t("menuItem"), flex: 20, sortable: false },
    { field: "path", headerName: t("path"), flex: 15, sortable: false },
    {
      field: "permissions",
      headerName: t("permissions"),
      flex: 20,
      sortable: false,
    },
    {
      field: "featureFlag",
      headerName: t("featureFlag"),
      flex: 12,
      sortable: false,
    },
    {
      field: "users",
      headerName: t("users"),
      flex: 8,
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "userNames",
      headerName: t("userNames"),
      flex: 25,
      sortable: false,
    },
  ];

  return (
    <HotkeyCompliantDataGrid
      rows={[]}
      columns={columns}
      loading
      slotProps={{
        loadingOverlay: {
          variant: "skeleton",
          noRowsVariant: "skeleton",
        },
      }}
      disableColumnReorder
      sx={{ minHeight: 200 }}
    />
  );
};
